import React from "react";

/* ============================================================
   The Debt Guy — Maca-style playful mark.
   A chunky black rounded badge with a white "glasses" icon and a
   lime accent dot. Pairs with an Archivo-Black wordmark.
   ============================================================ */

const INK = "#141414";
const LIME = "#D9F154";

/** The round glasses badge (icon only). */
export const GlassesMark = ({ size = 40, ink = INK, accent = LIME }) => (
  <svg viewBox="0 0 100 100" width={size} height={size} xmlns="http://www.w3.org/2000/svg" data-testid="glasses-mark">
    <rect x="3" y="3" width="94" height="94" rx="26" fill={ink} />
    {/* lime accent dot */}
    <circle cx="30" cy="27" r="7.5" fill={accent} />
    {/* glasses */}
    <g fill="none" stroke="#FFFFFF" strokeWidth="5.5" strokeLinecap="round">
      <circle cx="35" cy="58" r="15" />
      <circle cx="69" cy="58" r="15" />
      <path d="M49 55 Q52 50 55 55" />
      <path d="M20 55 L11 50" />
      <path d="M84 55 L93 50" />
    </g>
  </svg>
);

const Monogram = ({ color, size = 100 }) => <GlassesMark size={size} ink={color || INK} />;

/**
 * Horizontal lockup: glasses badge + "THE DEBT GUY" wordmark.
 */
export const CapitalGuyLogo = ({ size = 260, mode = "light" }) => {
  const color = mode === "dark" ? "#FFFFFF" : INK;
  const badgeInk = mode === "dark" ? "#FFFFFF" : INK;
  const badgeStroke = mode === "dark" ? INK : "#FFFFFF";
  const subColor = mode === "dark" ? "rgba(255,255,255,0.6)" : "#5B6B63";
  const s = size;
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: s * 0.06 }} data-testid="capital-guy-logo">
      <svg viewBox="0 0 100 100" width={s * 0.22} height={s * 0.22} xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="94" height="94" rx="26" fill={badgeInk} />
        <circle cx="30" cy="27" r="7.5" fill={LIME} />
        <g fill="none" stroke={badgeStroke} strokeWidth="5.5" strokeLinecap="round">
          <circle cx="35" cy="58" r="15" />
          <circle cx="69" cy="58" r="15" />
          <path d="M49 55 Q52 50 55 55" />
          <path d="M20 55 L11 50" />
          <path d="M84 55 L93 50" />
        </g>
      </svg>
      <div style={{ lineHeight: 1 }}>
        <div style={{ fontFamily: "'Archivo', sans-serif", fontSize: s * 0.14, fontWeight: 900, letterSpacing: "-0.02em", color, textTransform: "uppercase" }}>
          The Debt Guy
        </div>
        <div style={{ fontFamily: "'Archivo', sans-serif", fontSize: s * 0.052, fontWeight: 600, letterSpacing: "0.24em", color: subColor, textTransform: "uppercase", marginTop: s * 0.02 }}>
          by Ernesto Gómez Berjón
        </div>
      </div>
    </div>
  );
};

/** Compact fox badge mark for nav, footer, admin. */
export const LogoMark = ({ size = 40, mode = "light" }) => (
  <img
    data-testid="logo-mark"
    src="/logo-debtguy.png"
    alt="The Debt Guy"
    style={{ width: size, height: size, objectFit: "contain", display: "block", flexShrink: 0 }}
  />
);

export const Avatar = ({ initials, size = 52, src }) => {
  if (src) {
    return (
      <div style={{
        width: size, height: size, borderRadius: "50%", overflow: "hidden",
        border: "2px solid #141414", flexShrink: 0, background: "#E8F5E9",
      }}>
        <img src={src} alt={initials} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      </div>
    );
  }
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: LIME,
      border: "2px solid #141414",
      display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
    }}>
      <div style={{ fontFamily: "'Archivo', sans-serif", fontSize: size * 0.4, fontWeight: 800, color: INK, letterSpacing: "-0.03em" }}>
        {initials}
      </div>
    </div>
  );
};

export { Monogram };
